var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"v1.0.4"},[_c('v-main',[_c('router-view',{attrs:{"id":"v1.0.4"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }